// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-layout {
  background-color: #f6f8fc;
}
.main-layout__body {
  width: 100%;
}
.main-layout__body__content {
  overflow: auto;
  width: 100%;
}
.main-layout__body__content__detail {
  margin-top: 10px;
  width: 100%;
  display: flex;
}

.flat {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.class-trangchu {
  transition: width 600ms;
  margin: 15px 20px;
}

.class-chil {
  transition: width 600ms;
  position: relative;
  min-height: calc(100vh - 100px);
  padding: 10px 10px 10px 0px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 21.8644px 14.2119px rgba(41, 72, 152, 0.025), 0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296), 0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);
}`, "",{"version":3,"sources":["webpack://./src/styles/main-layout.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;AAAI;EACI,WAAA;AAER;AADQ;EACI,cAAA;EACA,WAAA;AAGZ;AAFY;EACI,gBAAA;EACA,WAAA;EACA,aAAA;AAIhB;;AAEA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AACJ;;AACA;EACI,uBAAA;EACA,iBAAA;AAEJ;;AAAA;EAEI,uBAAA;EACA,kBAAA;EAEA,+BAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,uKACI;AAAR","sourcesContent":[".main-layout {\r\n    background-color: #f6f8fc;\r\n    &__body {\r\n        width: 100%;\r\n        &__content {\r\n            overflow: auto;\r\n            width: 100%;\r\n            &__detail {\r\n                margin-top: 10px;\r\n                width: 100%;\r\n                display: flex;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.flat {\r\n    width: 100%;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n}\r\n.class-trangchu {\r\n    transition: width 600ms;\r\n    margin: 15px 20px;\r\n}\r\n.class-chil {\r\n    // min-width: fit-content;\r\n    transition: width 600ms;\r\n    position: relative;\r\n    // margin: 15px 20px;\r\n    min-height: calc(100vh - 100px);\r\n    padding: 10px 10px 10px 0px;\r\n    border-radius: 8px;\r\n    background-color: #ffffff;\r\n    box-shadow:\r\n        0px 21.8644px 14.2119px rgba(41, 72, 152, 0.025),\r\n        0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296),\r\n        0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);\r\n    \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
